import type { ModuleManifest, RequestFormDef } from "@dd/module-api";
import { lazy } from "react";

export const REGISTRO_FORMS: readonly RequestFormDef[] = [
  {
    id: "mod.registro:testamento",
    title: "Testamento protocolizado",
    description: "Copia de la página dispositiva del último protocolo de un causante.",
    fields: [{ id: "causante", label: "Causante", source: "cast" }],
  },
  {
    id: "mod.registro:transito",
    title: "Registro de tránsito",
    description: "Cruces registrados por concesionarias viales (peajes, viaductos).",
    fields: [
      {
        id: "tramo",
        label: "Tramo",
        source: "options",
        options: ["Viaducto Valdorra–Vespera", "Ruta de la Costa", "Acceso al muelle"],
      },
    ],
  },
] as const;

export const REGISTRO_MANIFEST: ModuleManifest = {
  id: "mod.registro",
  version: "1.0.0",
  title: "Registro Público",
  glyph: "◪",
  component: lazy(() => import("./RegistroApp")),
  defaultSize: { w: 540, h: 540 },
  artifactTypes: ["acta", "titulo", "partida"],
  requestForms: REGISTRO_FORMS,
  eraSkins: ["2011"],
};
